module.exports = __webpack_public_path__ + "img/33_21.cb7d87ac.png";